import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faCamera, faStickyNote, faTimes, faUpload, faUser } from '@fortawesome/free-solid-svg-icons';
import { WebcamImage } from 'ngx-webcam';
import { StudentService } from 'src/app/admin/services/student.service';
import { PractitionerService } from 'src/app/admin/services/practitioner.service';
import { ParentService } from 'src/app/admin/services/parent.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Parent } from 'backend/interfaces/parent.interface';
import { BusinessService } from 'src/app/admin/services/business.service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { Business } from 'backend/interfaces/business.interface';
import { StarRatingColor } from '../components/star-rating/star-rating.component';
interface DialogData {
  title: string;
  comment: string;
  business: any
}

@Component({
  selector: 'app-review-dialog',
  templateUrl: './review-dialog.component.html',
  styleUrls: ['./review-dialog.component.scss']
})
export class ReviewDialogComponent implements OnInit, AfterViewInit {
  faNote = faStickyNote;
  faClose = faTimes;
  title;
  comment;
  faUser = faUser;
  saving = false;
  business: Business;
  reviewForm: UntypedFormGroup;  

    rating:number = 3;
    starCount:number = 5;
    starColor:StarRatingColor = StarRatingColor.accent;
    starColorP:StarRatingColor = StarRatingColor.primary;
    starColorW:StarRatingColor = StarRatingColor.warn;
  // @ViewChild('recognitionFileInput') recognitionFileInput: ElementRef;
  constructor(public dialogRef: MatDialogRef<ReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private _snackBar: MatSnackBar, private fb: FormBuilder, private businessService: BusinessService) { }

  ngOnInit(): void {
    console.log(this.data)
    this.title = this.data.title;
    this.reviewForm = this.fb.group({
      title: [this.data.title],
      comment: [this.title.comment]
    })
  }

  ngAfterViewInit(){

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  
  async saveReview(): Promise<void>{
    this.saving = true;
    let review = {
      ...this.reviewForm.value,
      rating: this.rating
    }
      this.businessService.saveReview(this.data.business.id, review).then(res => {
        this.dialogRef.close(res);
        this.openSnackBar(res);
        this.saving = false;
      }).catch(err => {
        console.log(err);
      });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'OK', {
      duration: 3000
    });
  }

  onRatingChanged(rating){
    this.rating = rating;
  }
  
}

